import { Guid, IModelBase } from '@pmis3/core';

export interface ILocation extends IModelBase {
    id: Guid;
    parentId?: Guid;
    name: string;
    shortCode?: string;
    description?: string;
    locationTypeId: number;
    locationTypeName: string;
    isActive?: boolean;
    seq?: number;
    berthLOA?: number;
    // bollardBufferFront?: number;
    // bollardBufferBack?: number;
    // overhangFront?: number;
    // overhangBack?: number;
    bollardNumber?: number;
    adminsDraft?: number;
    //TODO
    //outages
}

export interface LocationForBerthPlanner extends ILocation {
    childrenLocation?: LocationForBerthPlanner[];
    bollardDistance?: number;
    bollardDistanceMeters?: number;
    // equipments?: IEquipment[];
    totalBerthLOA?: number;
    roundedTotalBerthLOA?: number;
    berthMarkings?: IBerthPlanMarkings[];
    startMeter?: number;
    endMeter?: number;
    placeable?: number;
    assignId?: number;
    cssClass?: string;
    placedMessage?: string;
    reverseOrientation?: boolean;
}

export interface IBerthPlanMarkings {
    markingDistance: number;
    markingSequence?: number;
    name: string;
    shortCode: string;
    id?: Guid;
}

export interface ILocationOutage {
    locationId: string;
    location: ILocation;
    status: LocationOutageStatusEnum;
    outageType: string;
    startTime: Date;
    endTime: Date;
}

export enum LocationOutageStatusEnum {
    Draft = 'Draft',
    ReadyForApproval = 'Ready For Approval',
    Approved = 'Approved',
    Cancelled = 'Cancelled',
}

export interface ILocationType {
    id?: number;
    name?: string;
}

export enum LocationTypeForNOA {
    PilotStation = 'Pilot Station',
    Terminal = 'Terminal',
    Berth = 'Berth'
}

export interface ILocationForNOA extends IModelBase {
    id: number;
    locationType?: LocationTypeForNOA;
    parentId?: number;
    name?: string;
    shortCode?: string;
    locationTypeId?: number;
    locationTypeName?: string;
}